export default __webpack_public_path__ + "static/media/isologo.607641f7.png";